import { BannerFullWidth, BannerSplit, BannerText } from '@components/common/Banner'
import { PrismicImage, PrismicMedia } from '@lib/prismic'
import { RichTextBlock } from 'prismic-reactjs'
import { FC } from 'react'

interface BannerProps {
  primary: {
    banner_type: 'Full Width' | 'Split' | 'Text'
    banner_title?: string
    description?: RichTextBlock[]
    background_color?: string
    link?: string
    icon_position: 'Top' | 'Bottom' | 'Left' | 'Right'
    icon?: PrismicImage
    desktop_image?: PrismicImage
    mobile_image?: PrismicImage
    font: 'heading1-Bradford' | 'heading2' | 'core-brand'
    video: PrismicMedia
    border_bottom: boolean
    mobile_border_bottom: boolean
  }
}

const Banner: FC<BannerProps> = ({ primary }) => {
  const { banner_type: type } = primary

  const renderBanner = () => {
    switch (type) {
      case 'Full Width':
        return (
          <section className="banner">
            <BannerFullWidth {...primary} />
          </section>
        )
      case 'Split':
        return (
          <section className="banner">
            <BannerSplit {...primary} />
          </section>
        )
      case 'Text':
        return (
          <section className="banner">
            <BannerText
              {...primary}
              border_bottom={primary.border_bottom}
              mobile_border_bottom={primary.mobile_border_bottom}
            />
          </section>
        )
      default:
        return null
    }
  }

  return <> {renderBanner()}</>
}

export default Banner
